import mitt from 'mitt';

type FeedCommentsEvents = {
  deleted: { messageId: number; commentId: number };
  likeUpdated: {
    messageId: number;
    commentId: number;
    memberId: number;
    likesCount: number;
    liked: boolean;
  };
};

export const feedCommentsEmitter = mitt<FeedCommentsEvents>();
